<template>
  <div class="d-flex p-5" id="wrapper">
    <div class="container">
        <div class="row mt-4">
            <div class="col-md-8 offset-md-2">
                <div class="card p-5" style="display:flex;flex-direction:column;align-items:center;justify-content:center;">

                <div class="info-body" >
                    <h3 class="card-login-title text-center mb-4">Forgot Password</h3>
                    <div class="illustration illustration-sm">
                        <img src="/img/thinking.svg" alt="">
                    </div>
                    <p class="text-center mb-4">Input your email address and we will send you a link to reset your password</p>
                    <form action="" method="POST">
                        <div class="form-group">
                            <input type="email" class="form-control" name="email" aria-describedby="emailHelp" placeholder="Enter email address">
                            <small id="emailFound"></small>
                            <h6 class="text-danger mt-2">
                                <!-- {{ getErrorFor('password') }} -->
                                Error
                            </h6>
                        </div>
                        <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;">
                            <button type="submit" id="btnSubmit" class="btn btn-primary">Send Reset Password Link</button>
                        </div>
                    </form>
                </div>
            </div>
            </div>
        </div>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src

export default {
  name: 'ForgotPassword',
  components: {
  },
  data:()=>{
    return { fromUrl:'',plainUrl:'',
    };
  }
}
</script>

